import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';

import formatCurrency from 'rebook/apps/utils/text/formatCurrency';
import Form, { FormRow, FormControl } from 'rebook/apps/base/components/form/Form';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import Button from 'rebook/apps/base/components/Button';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';
import validateForm from 'rebook/apps/base/components/form/validateForm';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import uaDetector from 'rebook/apps/utils/uaDetector';
import { URLS } from 'rebook/apps/base/constants';
import { OFFER_PAGE_ERROR_MESSAGES } from 'rebook/apps/offer/constants';
import TrialCardHeaderItem from 'rebook/apps/trial/components/TrialCardHeaderItem';
import TrialCardBillingInfo from 'rebook/apps/trial/components/TrialCardBillingInfo';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';

import styles from './style.scss';


class WeekTrialView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      errorList: {},
      isDisabled: false,
      isInProgress: false,
      trialPayment: null,
    };
  }

  componentWillUnmount() {
    Cookies.remove('secondStep');
  }

  onBeforeSubmit() {
    ga('send', 'event', {
      eventCategory: 'MybookEvent Subscription',
      eventAction: 'Offer_Step2',
      eventLabel: 'Audio',
      dimension1: '14trial',
    });
    yaMetrikaReachGoal('Offer_Step2', { offer: 'Audio_14trial' });
  }

  updateFormField(input) {
    this.setState(
      (prevState) => {
        return {
          errorList: {},
          form: {
            ...prevState.form,
            ...input,
          },
        };
      },
    );
  }

  handleOpenPayonline() {
    this.setState({
      errorList: {},
      isInProgress: true,
    });
    const options = {
      method: 'post',
      json: {
        provider: 'web',
        data: {
          payment_method: 'payonline_trial',
          sub_months: '1',
          sub_type: 'audio',
          trial_type: 'two_weeks',
        },
      },
    };
    fetchQuery('/api/payments/', options)
      .then(({ data }) => {
        this.setState({
          trialPayment: data,
          isInProgress: false,
        });
      })
      .catch(({ data, resp }) => {
        Raven.captureMessage('failed to submit trial payment list due to server error', {
          level: 'error',
          extra: {
            status: resp.status,
            response: data,
          },
        });
        this.setState({ isInProgress: false });
        this.props.NotificationActions.pop(data[0], 'error');
      });
  }

  handleSubmit(submit) {
    const { user } = this.props;
    ga('send', 'event', {
      eventCategory: 'MybookEvent Subscription',
      eventAction: 'Offer_Step2',
      eventLabel: 'Audio',
      dimension1: '14trial',
    });
    yaMetrikaReachGoal('Offer_Step2', { offer: 'Audio_14trial' });
    if (!user) {
      const form = validateForm(this.state.form);

      if (form.errorList) {
        this.handleError(form.errorList);

        return;
      }

      submit(form);
      this.setState({
        errorList: {},
        isInProgress: true,
      });
    }
    else {
      this.handleOpenPayonline();
    }
  }

  handleSuccess() {
    ga('send', 'event', 'Registration', 'Registration', 'Offer');
    yaMetrikaReachGoal('Registration');
    this.setState({ isInProgress: false });
    window.location.assign('/trial/');
    var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
    Cookies.set('secondStep', 1, {
      expires: inFifteenMinutes,
    });
  }

  handleError(errorList) {
    this.setState({
      errorList,
      isInProgress: false,
    });

    if (errorList.non_field_errors) {
      this.props.NotificationActions.pop(errorList.non_field_errors, 'error');
    }
  }

  handleCloseModalWindow() {
    this.setState({ trialPayment: null });
  }

  getPayDialog() {
    const { trialPayment } = this.state;
    if (!trialPayment) {
      return null;
    }
    const UA = navigator && navigator.userAgent ? navigator.userAgent : null;
    return (
      <ModalDialog onClose={() => {
        this.handleCloseModalWindow();
      }} dialog={
        {
          id: '1',
          extraClassName: 'jest-payonline-window',
          emojiIcon: '',
          title: '',
          content:
            <div>
              <iframe
                width="100%"
                height={uaDetector.isMobile(UA) ? '255' : '310'}
                className={styles.trialForm}
                src={trialPayment.redirect_url}
                frameBorder="0" />
            </div>,
        }
      } />
    );
  }

  render() {
    const { errorList, isDisabled, isInProgress, trialPayment } = this.state;
    const { user, offer, booksPerSubscriptionCounter, payments } = this.props;
    const modalWindow = this.getPayDialog();
    const userHadAudio = !!get(user, 'subscription_audio_active_till', null);
    const price = get(payments, 'prices.audio.full_price', 459);
    const isNeededSecondStep = Cookies.get('secondStep');

    return (
      <React.Fragment>
        <div className={classNames(styles.offerPage)}>
          <div className={styles.header}>
            <h1>
              Получите 14&nbsp;дней подписки <br className={styles.wordWrap} />бесплатно
            </h1>
          </div>
          {trialPayment ? modalWindow : null}
          <div className={styles.offerForm}>
            <div className={styles.title}>
              <TrialCardHeaderItem imageStyleName={styles.proSubscriptionIcon}>
                <span>
                  Получите бесплатную подписку
                  на <b>14 дней</b> за привязку карты&nbsp;<br />
                </span>
                <span>
                  и читайте и слушайте<br />
                  <b>
                    {numberWithSpace(booksPerSubscriptionCounter.total)}
                    &nbsp;книг&nbsp;
                  </b>
                </span>
                <span>
                  и&nbsp;
                  <b>
                    {numberWithSpace(booksPerSubscriptionCounter.audio)}
                  </b>
                  <b>&nbsp;аудиокниг</b>
                </span>
              </TrialCardHeaderItem>
              <TrialCardHeaderItem className={styles.showOnDesktop} imageStyleName={styles.calendarIcon}>
                <span>
                  Через <b>14 дней</b> подписка продлится на месяц за&nbsp;
                  <b>{formatCurrency(price, 'RUB')}</b>
                </span>
              </TrialCardHeaderItem>
            </div>
            {userHadAudio && (
              <div className={styles.subscriptionAlert}>
                <div className={styles.subscriptionAlertImage} />
                <span className={styles.subscriptionAlertTitle}>
                  Вы не можете воспользоваться этим предложением, потому что у вас уже была такая подписка
                </span>
              </div>
            )}
            {!userHadAudio && get(offer, 'errors.length', 0) === 0 &&
            <Form
              action="/api/registration/"
              method="post"
              extraClassName={classNames('jest-week-offer-form', styles.form)}
              onBeforeSubmit={() => this.onBeforeSubmit()}
              onSubmit={(callback) => this.handleSubmit(callback)}
              onSuccess={(data) => this.handleSuccess(data)}
              onError={(errorList) => this.handleError(errorList)}>
              {!user && (
                <React.Fragment>
                  <div className={styles.steps}>
                    <div className={styles.stepsProgress}>
                      <span className={styles.progressLabel}>1</span>
                    </div>
                    <div className={styles.stepsHeading}>Регистрация</div>
                  </div>
                  <FormRow>
                    <FormTextInput
                      extraClassName={classNames('jest-email-form-input', styles.input)}
                      validationMessageExtraClassName="jest-email-form-input-error"
                      errorList={errorList.email}
                      isDisabled={isDisabled || isInProgress}
                      isRequired
                      isRequiredError={OFFER_PAGE_ERROR_MESSAGES.EMAIL_IS_REQUIRED}
                      label="Введите вашу электронную почту"
                      onUpdate={(input) => this.updateFormField(input)}
                      name="email" />
                  </FormRow>
                </React.Fragment>
              )}
              {isNeededSecondStep && (
                <div>
                  <div className={styles.steps}>
                    <div className={styles.stepsProgressSecond}>
                      <span className={styles.progressLabel}>2</span>
                    </div>
                    <div className={styles.stepsHeading}>Оформление подписки</div>
                    <div className={styles.stepsSubheading}>Поздравляем, вы успешно зарегистрировались! Остался
                      последний шаг
                    </div>
                  </div>
                </div>
              )}
              <FormControl>
                <Button
                  type="submit"
                  extraClassName="jest-registration-form-submit"
                  size="small"
                  theme="advert"
                  isInProgress={isInProgress}>
                  {!user ? 'Зарегистрироваться' : 'Оформить подписку'}
                </Button>
              </FormControl>
            </Form>
            }
          </div>
          <div className={styles.billingInfoContainer}>
            <TrialCardBillingInfo imageStyleName={styles.applyIcon}>
              <span className={styles.note}>
                Оплачивая подписку, я принимаю&nbsp;
                <Link to={`${URLS.aboutOffer}#a4.4`} className="link">условия оплаты, указанные в оферте,</Link>
                <span>
                  &nbsp;и&nbsp;
                  <Link to={`${URLS.aboutOffer}#a4.4`} className="link">
                    условия автоматического продления подписки на месяц вперед.
                  </Link>
                </span>
              </span>
            </TrialCardBillingInfo>
            <TrialCardBillingInfo imageStyleName={styles.noComissionIcon}>
              <span>Отменить платное продление подписки можно в любой момент в настройках</span>
            </TrialCardBillingInfo>
            <TrialCardBillingInfo imageStyleName={styles.lockIcon}>
              <span>Все платежи надежно защищены и соответствуют международным стандартам.</span>
            </TrialCardBillingInfo>
          </div>
        </div>
        <div className={styles.backgroundImageContainer}>
          <div className={styles.backgroundImage} />
        </div>
      </React.Fragment>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    payments: state.payments,
    offer: state.offer,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
};

const mapDispatchToProps = (dispatch) => ({
  NotificationActions: bindActionCreators(NotificationActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WeekTrialView);
